import { Button } from '@/components/ui/button'
import type { FillCardForm } from '../App/Customers/FillApplication/useFillCardSave'

interface ReviewSectionFooterProps {
  /** Cancel drops what it holds and Save sends it; Save waits for something to send. */
  form: FillCardForm
  onCancel: () => void
  onClose: () => void
}

export function ReviewSectionFooter({ form, onCancel, onClose }: ReviewSectionFooterProps) {
  async function save() {
    if (await form.save()) onClose()
  }

  return (
    <>
      <Button type="button" variant="outline" className="text-md" disabled={form.saving} onClick={onCancel}>
        Cancel
      </Button>
      <Button
        type="button"
        className="text-md"
        loading={form.saving ? 'Saving…' : undefined}
        disabled={!form.isDirty}
        onClick={() => void save()}
      >
        Save
      </Button>
    </>
  )
}
